export class SelectionModel {
    id: string;
    isLive: boolean;
    name: string;
    viewKey: number;
    eventType: string;
    suspended: boolean;

    constructor(source: SelectionModel) {
        this.id = source.id;
        this.isLive = source.isLive;
        this.name = source.name;
        this.viewKey = source.viewKey;
        this.eventType = source.eventType;
        this.suspended = source.suspended;
    }
}